export default __webpack_public_path__ + "static/SRUS P285 - Product Specifications & Technical Data-b04be2856b2265c09cd6940448955de5.pdf";